import { render, staticRenderFns } from "./MonProfil.vue?vue&type=template&id=24a1cb1a&"
import script from "./MonProfil.vue?vue&type=script&lang=js&"
export * from "./MonProfil.vue?vue&type=script&lang=js&"
import style0 from "./MonProfil.vue?vue&type=style&index=0&id=24a1cb1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports